import { UPDATE_TABLES } from "../../actions/QueryBuilder/actionConstants";

const tableHash = (state = {}, action) => {
	switch (action.type) {
		/**
		 * action: {
		 *  type,
		 *  tableHash
		 * }
		 */
		case UPDATE_TABLES:
			return action.tableHash;
		default:
			return state;
	}
};

export default tableHash;
